import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AbsenceLeaveDetailsComponent} from "./absence-leave-details/details.component";

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateAbsenceDetails implements CanDeactivate<AbsenceLeaveDetailsComponent>
{
    canDeactivate(
        component: AbsenceLeaveDetailsComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        // Get the next route
        let nextRoute: ActivatedRouteSnapshot = nextState.root;
        while ( nextRoute.firstChild )
        {
            nextRoute = nextRoute.firstChild;
        }

        // If the next state doesn't contain '/leave-management'
        // it means we are navigating away from the
        // leave-management app
        if ( !nextState.url.includes('/leave-management') )
        {
            // Let it navigate
            // return true;
            let result = component.canDeactivate()
            return result
        }

        // If we are navigating to another contact ...
        if ( nextState.url.includes('/leave-management') && nextRoute.paramMap.get('id') )
        {
            // Just navigate
            // return true;
            let result = component.canDeactivate()
            return result
        }
        // Otherwise...
        else
        {
            let result = component.canDeactivate()
            console.log("result", result)
            if (!result) {
                // Close the drawer first, and then navigate
                // component.closeDrawer().then(() => true);
                return result
            } else {
                // Close the drawer first, and then navigate
                component.closeDrawer().then(() => true);
                return result
            }
            // return component.closeDrawer().then(() => true);
        }
    }
}
